var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-search-browse",
    {
      attrs: {
        "data-source": _vm.dataSource,
        multiple: !_vm.single,
        "selected-items": _vm.selectedProducts,
        "clear-view-settings-filters": _vm.generalSettings.ClearF3SearchFilter,
        "search-string": _vm.searchString,
        view: _vm.view,
      },
      on: {
        "select-changed": function ($event) {
          return _vm.onSelectChanged($event)
        },
        "search-changed": function ($event) {
          return _vm.$emit("search-changed", $event)
        },
      },
    },
    [
      _c(
        "template",
        { slot: "browse-action-buttons" },
        [
          _c(
            "w-button",
            {
              staticClass: "ml",
              attrs: { icon: "check", disabled: _vm.confirmDisabled },
              on: {
                click: function ($event) {
                  return _vm.onClick()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }